import { useRef } from "react";
import "./PaymentReceipt.css";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const PaymentReceipt = ({ isOpen, onClose, bookingDetails }) => {
  const receiptRef = useRef(null);

  if (!isOpen || !bookingDetails) return null;

  const handleDownloadPDF = async () => {
    const element = receiptRef.current;
    if (!element) return;

    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        backgroundColor: "#ffffff",
        logging: false,
        useCORS: true
      });
      
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4"
      });
      
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`receipt_${bookingDetails.receiptId || "booking"}.pdf`);
      
    } catch (error) {
      console.error("Error generating PDF:", error);
      alert("Failed to generate PDF. Please try again.");
    }
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="receipt-overlay" onClick={onClose}>
      <div className="receipt-modal" onClick={(e) => e.stopPropagation()}>
        <button className="receipt-close-btn" onClick={onClose}>×</button>
        
        <div className="receipt-content" ref={receiptRef}>
          <div className="receipt-header">
            <h2>🧾 PAYMENT RECEIPT</h2>
            <p className="receipt-id">Receipt #: {bookingDetails.receiptId || 'N/A'}</p>
          </div>

          <div className="receipt-body">
            {/* Booking Details Section */}
            <div className="receipt-section">
              <h4>📋 BOOKING DETAILS</h4>
              <div className="receipt-row">
                <span className="label">Event Name:</span>
                <span className="value">{bookingDetails.eventName}</span>
              </div>
              <div className="receipt-row">
                <span className="label">Event Date:</span>
                <span className="value">{bookingDetails.eventDate ? new Date(bookingDetails.eventDate).toLocaleDateString() : 'N/A'}</span>
              </div>
              <div className="receipt-row">
                <span className="label">Venue:</span>
                <span className="value">{bookingDetails.eventPlace || "Main Arena"}</span>
              </div>
              <div className="receipt-row">
                <span className="label">Item Type:</span>
                <span className="value">{bookingDetails.itemType === 'stall' ? 'Stall' : 'Stall'}</span>
              </div>
              <div className="receipt-row">
                <span className="label">Stall Number:</span>
                <span className="value">#{bookingDetails.itemNumber}</span>
              </div>
              <div className="receipt-row">
                <span className="label">Booking Time:</span>
                <span className="value">{bookingDetails.bookingTime ? new Date(bookingDetails.bookingTime).toLocaleString() : new Date().toLocaleString()}</span>
              </div>
            </div>

            {/* Customer Details Section */}
            <div className="receipt-section">
              <h4>👤 CUSTOMER DETAILS</h4>
              <div className="receipt-row">
                <span className="label">Name:</span>
                <span className="value">{bookingDetails.customer?.name}</span>
              </div>
              <div className="receipt-row">
                <span className="label">Phone:</span>
                <span className="value">{bookingDetails.customer?.phone}</span>
              </div>
              <div className="receipt-row">
                <span className="label">Email:</span>
                <span className="value">{bookingDetails.customer?.email || 'N/A'}</span>
              </div>
            </div>

            {/* Payment Details Section */}
            <div className="receipt-section">
              <h4>💰 PAYMENT DETAILS</h4>
              <div className="receipt-row">
                <span className="label">Payment ID:</span>
                <span className="value">{bookingDetails.paymentId}</span>
              </div>
              <div className="receipt-row">
                <span className="label">Order ID:</span>
                <span className="value">{bookingDetails.orderId}</span>
              </div>
              <div className="receipt-row">
                <span className="label">Amount Paid:</span>
                <span className="value amount">₹{bookingDetails.amount?.toLocaleString()}</span>
              </div>
              <div className="receipt-row">
                <span className="label">Payment Method:</span>
                <span className="value">Razorpay</span>
              </div>
              <div className="receipt-row">
                <span className="label">Payment Status:</span>
                <span className="value status-success">SUCCESS</span>
              </div>
            </div>
          </div>

          <div className="receipt-footer">
            <p className="thank-you">Thank you for choosing Royal Heritage Fiesta!</p>
            <div className="receipt-actions">
              <button className="btn-print" onClick={handlePrint}>🖨️ Print</button>
              <button className="btn-download" onClick={handleDownloadPDF}>📥 Download PDF</button>
            </div>
            <p className="footer-note">This is a computer generated receipt - No signature required</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentReceipt;